import { ChangeDetectionStrategy, Component } from '@angular/core'
import { MatDivider } from '@angular/material/divider'
import { ElderNavModule } from '@elderbyte/ngx-starter'

@Component({
  selector: 'app-main-nav-menu',
  imports: [ElderNavModule, MatDivider],
  templateUrl: './main-nav-menu.component.html',
  styleUrl: './main-nav-menu.component.scss',
})
export class MainNavMenuComponent {}
